import { getOrCreateVisitorId } from '@/lib/visitor-id'

export type ProgrammerEvent =
  | 'visit'
  | 'connect_attempt'
  | 'read_success'
  | 'read_failure'
  | 'write_attempt'
  | 'write_success'
  | 'write_failure'

export function trackProgrammerEvent(
  event: ProgrammerEvent,
  model: string,
): void {
  const id = getOrCreateVisitorId()
  if (!id) return
  void fetch('/api/web-programmer/event', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id, event, model }),
    keepalive: true,
  }).catch(() => {})
}
